import { BaseEntity, Transform, toDate, toEntity } from './base';
import { TruckModel } from './truck';
export class FillerShiftModel extends BaseEntity {
  fillerId?: number;
  truckId?: number;
  routeId?: number;

  @Transform(toEntity(TruckModel))
  truck?: TruckModel;

  @Transform(toDate)
  clockIn?: Date;

  @Transform(toDate)
  clockOut?: Date;
}



// WEBPACK FOOTER //
// ./src/models/filler-shift.ts